import { Grid } from "@material-ui/core";
import { ComponentProps, FC, FunctionComponent, useContext } from "react";
import styled from "styled-components";
import { AnySchema } from "yup";
import { columnFlex, Flex, GridItem } from "../../../../components/layout";
import { WIDGET_BORDER_RADIUS } from "../../../../components/widget";
import { ConfigContext } from "../../../../pages/token-onboarding/single/config-context";
import { colours } from "../../../../styles/colours";
import { ServiceType } from "../../../verification/models/internal";
import { LaunchConfigurationsDTO } from "../dto";
import { Field } from "../internal/field";

export type RenderFuncProps = {
  item: Field.DefaultField;
};

export const FullWidthItem = styled.div`
  grid-column-start: 1;
  grid-column-end: 3;

  & {
    text-align: left !important;
  }
`;

export const Description = styled(FullWidthItem)`
  font-size: 0.8em;
`;

export const Title = styled(Description)`
  font-size: 1em;
  font-weight: 500;
`;

const InnerWrapper = styled(FullWidthItem)<{ border?: string }>`
  border: 1px solid ${({ border }) => border ?? "transparent"};
  padding: 1em;
  border-radius: ${WIDGET_BORDER_RADIUS};
  & > *:nth-child(2n + 1) {
    text-align: left;
  }
`;

export const Wrapper: FunctionComponent<
  Omit<ComponentProps<typeof InnerWrapper>, "border"> & {
    coloured?: boolean;
  }
> = ({ coloured, ...props }) => {
  const { config } = useContext(ConfigContext);

  return (
    <InnerWrapper
      border={
        coloured ? config.configuration.css.buttonPrimaryColor : undefined
      }
      {...props}
    ></InnerWrapper>
  );
};

export const CenteredContainer = styled(Grid).attrs({ container: true })`
  justify-content: center;
  text-align: center;
`;

export const RightAlignedGridItem = styled(GridItem)`
  justify-content: flex-end;
`;

export const ErrorText = styled.div`
  color: ${colours.red};
  margin-top: 0.3em;
`;

export const ColumnWrapper = styled.div`
  ${columnFlex};
  flex-grow: 1;
`;

/**
 * Definition of the field itself e.g. names field will include
 * name, surname, middlename
 */
export type FieldHook<T = RenderFuncProps> = () => {
  schema:
    | ((
        f: Field.DefaultField,
        config: LaunchConfigurationsDTO.Responses.GetSingle.T
      ) => AnySchema)
    | AnySchema;
  elem: FC<T>;
  service?: typeof ServiceType.T;
  cryptoField?: boolean;
  skipOptionalCheck?: boolean;
};

/**
 * Definition of the field meta e.g. names field will include
 * minCharacters
 * lastNameRequired
 */
export type FieldConfigHook<T = {}> = () => Pick<
  ReturnType<FieldHook<T>>,
  "elem" | "schema"
>;

export const ConfirmText = styled.div<{ ticked?: boolean }>`
  display: flex;
  align-items: center;
  opacity: ${(props) => (props.ticked ? 1 : 0.3)};
  font-size: 0.9em;
  text-transform: uppercase;
`;

export const ToggleWrapper = styled(Flex)`
  justify-content: flex-end;
`;
